import useBreakpoint from "hooks/useBreakpoint";
import Header from "components/core/Header/Header";
import SideMenu from "components/core/SideMenu/SideMenu";
import useSideMenuTiles from "components/core/SideMenu/useSideMenuTiles";
import { DesktopLayout, DesktopContent } from "./styles.basePageView";

export default function BasePageView({
  DesktopView,
  MobileView,
  viewProps = {},
  hideSideMenu = false,
  headerProps = {},
}) {
  const { orderTiles, setFailedIconIds } = useSideMenuTiles();

  const resolvedHeaderProps = {
    showLogout: false,
    showProfile: true,
    ...headerProps,
  };

  const { isMobile } = useBreakpoint();

  return (
    <>
      <Header {...resolvedHeaderProps} />
      {isMobile ? (
        <MobileView {...viewProps} />
      ) : (
        <DesktopLayout>
          {!hideSideMenu && (
            <SideMenu
              orderTiles={orderTiles}
              setFailedIconIds={setFailedIconIds}
            />
          )}
          <DesktopContent>
            <DesktopView {...viewProps} />
          </DesktopContent>
        </DesktopLayout>
      )}
    </>
  );
}
